export const SET_HOME = 'SET_HOME';